export function formatAppVersion(version = {}) {
	const appVersion = version || {};
	const prefix = appVersion.prefix || "Version";
	const versionNumber = [
		appVersion.major,
		appVersion.minor,
		appVersion.revision,
		appVersion.build
	]
		.filter((piece) => piece !== undefined && piece !== null && `${piece}` !== "")
		.join(".");
	const suffix = appVersion.suffix ? ` ${appVersion.suffix}` : "";

	return versionNumber ? `${prefix} ${versionNumber}${suffix}` : "";
}
